module.exports = __webpack_public_path__ + "static/media/tab-macbook.66c7c1fb.png";